import React from 'react';
import { RichText } from './RichText';
import { instantItems, worksheetsImage } from '../../data/landing';
export function InstantDelivery() {
  return <section aria-labelledby="instant-title" className="bg-sand py-16 md:py-24" data-id="element-116" data-mp="1mq9vfmz4n9cy">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16" data-id="element-117" data-mp="1rjmi3rk8x632">
        <div className="order-2 lg:order-1" data-id="element-118" data-mp="1who2cfterbg4">
          <img src={worksheetsImage} alt="Fichas terapéuticas imprimibles sobre un escritorio: termómetro de emociones, caras de sentimientos y tarjetas de respiración" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-[0_24px_48px_-24px_rgba(34,48,47,0.4)]" data-id="element-119" data-mp="zs6lr5sw04zn" />
        </div>
        <div className="order-1 text-center lg:order-2 lg:text-left" data-id="element-120" data-mp="1dsppw1u8eqwj">
          <h2 id="instant-title" className="font-serif text-[2.1rem] leading-[1.08] text-ink md:text-5xl" data-id="element-121" data-mp="2k80ey3zllwd1">
            ¿Qué recibís al instante?
          </h2>
          <ul className="mt-10 space-y-3" data-id="element-122" data-mp="2p50fjzdoi6wr">
            {instantItems.map(({
            icon: Icon,
            title
          }) => <li key={title} className="flex items-center justify-center gap-3 rounded-2xl bg-paper px-6 py-5 text-[17px] font-bold text-ink lg:justify-start" data-id="element-123" data-mp="3dglanyyyj33y">
                <Icon className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" data-id="element-124" data-mp="34ju9x99gn031" />
                <RichText text={title} data-id="element-125" data-mp="2zl0tb7yvmsyn" />
              </li>)}
          </ul>
          <p className="mt-10 font-serif text-2xl italic text-primary md:text-3xl" data-id="element-126" data-mp="2uleif56itot0">Cubrís todo tu año de sesiones</p>
        </div>
      </div>
    </section>;
}